import React, { useState } from 'react';

import { Button, Container, Grid, makeStyles, Typography } from '@material-ui/core';

const useStyles = makeStyles(() => {
  return {
    btn: {
      marginTop: '30px',
      width: '40%',
    },
    container: {
      padding: '50px 40px',
    },
    formTitle: {
      color: '#172B4D',
      fontWeight: 'bold',
      marginBottom: '1rem',
    },
    message: {
      color: '#999999',
      fontSize: '14px',
      lineHeight: '22px',
      marginBottom: '1rem',
      textAlign: 'center',
    },
  };
});

export default ({ title, message, okBtnText, okBtnAction, cancelBtnText, cancelBtnAction }) => {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);

  const handleOkClick = async () => {
    try {
      setLoading(true);
      await okBtnAction();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm" disableGutters className={classes.container}>
      <Grid container justifyContent="center">
        <Grid item xs={12}>
          <Typography variant="h4" className={`page-header ${classes.formTitle}`} align="center">
            {title}
          </Typography>
        </Grid>

        <Grid item xs={12}>
          {React.isValidElement(message) ? (
            message
          ) : (
            <Typography variant="body1" className={`body-copy ${classes.message}`} align="center">
              {message}
            </Typography>
          )}
        </Grid>

        <Button variant="outlined" size="medium" color="primary" onClick={cancelBtnAction} className={classes.btn} disabled={loading}>
          {cancelBtnText}
        </Button>

        <Button style={{ marginLeft: '5%' }} variant="contained" size="medium" color="primary" onClick={handleOkClick} className={classes.btn} disabled={loading} loading={loading}>
          {okBtnText}
        </Button>
      </Grid>
    </Container>
  );
};
